module.exports = new __parcel__URL__("spotlight-image.4d9b4434.svg").toString();